@if (visible) {
<section
  class="assistant-chat tw-fixed tw-right-4 tw-bottom-4 tw-top-[5.5rem] tw-z-40 tw-flex tw-w-[25rem] tw-max-w-[calc(100vw-2rem)] tw-flex-col tw-overflow-hidden tw-rounded-xl tw-border tw-border-solid tw-border-gray-200 tw-bg-white tw-text-gray-700 tw-shadow-[0_10px_34px_rgba(27,36,48,0.16),0_2px_8px_rgba(27,36,48,0.08)]"
  [attr.aria-label]="title"
>
  <div
    class="tw-flex tw-flex-none tw-items-center tw-gap-2.5 tw-bg-[linear-gradient(135deg,theme(colors.burt-purple),theme(colors.purple.600))] tw-px-3 tw-py-3 tw-text-white"
  >
    <div
      class="tw-flex tw-h-8 tw-w-8 tw-flex-none tw-items-center tw-justify-center tw-rounded-lg tw-bg-[rgba(255,255,255,0.18)]"
    >
      <i class="fa-regular fa-sparkles tw-text-base"></i>
    </div>
    <div class="tw-min-w-0">
      <div class="tw-text-base tw-font-semibold tw-leading-tight">{{ title }}</div>
      <div class="tw-flex tw-items-center tw-gap-1.5 tw-text-xs tw-opacity-85">
        <span class="tw-h-1.5 tw-w-1.5 tw-flex-none tw-rounded-full tw-bg-green-200"></span>
        {{ subtitle }}
      </div>
    </div>
    <div class="tw-flex-1"></div>
    @if (canRestart) {
    <button
      type="button"
      class="tw-flex tw-h-6 tw-w-6 tw-flex-none tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-md tw-border-0 tw-bg-[rgba(255,255,255,0.14)] tw-p-0 tw-text-white hover:tw-bg-[rgba(255,255,255,0.26)] disabled:tw-cursor-default disabled:tw-opacity-40 disabled:hover:tw-bg-[rgba(255,255,255,0.14)]"
      aria-label="Start over"
      [title]="restartTitle"
      [disabled]="typing"
      (click)="restart()"
    >
      <i class="fa-regular fa-arrow-rotate-left tw-text-sm"></i>
    </button>
    }
    <button
      type="button"
      class="tw-flex tw-h-6 tw-w-6 tw-flex-none tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-md tw-border-0 tw-bg-[rgba(255,255,255,0.14)] tw-p-0 tw-text-white hover:tw-bg-[rgba(255,255,255,0.26)]"
      aria-label="Close assistant"
      title="Close"
      (click)="close()"
    >
      <i class="fa-solid fa-xmark tw-text-base"></i>
    </button>
  </div>

  @if (contextLabel || contextDates) {
  <div
    class="tw-mx-3 tw-mt-2.5 tw-flex tw-flex-none tw-items-center tw-gap-2 tw-rounded-lg tw-border tw-border-solid tw-border-purple-100 tw-bg-purple-50 tw-px-2.5 tw-py-2"
  >
    <i class="fa-regular fa-presentation-screen tw-flex-none tw-text-sm tw-text-purple-700"></i>
    <div class="tw-min-w-0">
      <div class="tw-text-xs tw-font-bold tw-uppercase tw-tracking-wider tw-text-purple-700">Context</div>
      @if (contextLabel) {
      <div
        class="tw-truncate tw-text-sm tw-leading-normal tw-text-surface-600"
        [title]="contextLabel"
      >
        {{ contextLabel }}
      </div>
      } @if (contextDates) {
      <div class="tw-truncate tw-text-sm tw-leading-normal tw-text-surface-600">{{ contextDates }}</div>
      }
    </div>
  </div>
  }

  <div
    #thread
    class="tw-flex tw-min-h-0 tw-flex-1 tw-flex-col tw-overflow-y-auto tw-px-3 tw-pb-1.5 tw-pt-3.5"
  >
    <div class="tw-mt-auto tw-flex tw-flex-col tw-gap-3.5">
      @for (message of messages; track $index) { @if (message.role === 'user') {
      <div class="tw-flex tw-flex-none tw-justify-end">
        <div
          class="tw-max-w-[85%] tw-rounded-[12px_12px_3px_12px] tw-bg-burt-purple tw-px-3 tw-py-2 tw-text-sm tw-leading-normal tw-text-white"
        >
          {{ message.text }}
        </div>
      </div>
      } @else {
      <div
        class="tw-flex tw-min-w-0 tw-flex-none tw-flex-col tw-gap-2.5"
        [class.tw-border-0]="message.meta?.failed"
        [class.tw-border-l-2]="message.meta?.failed"
        [class.tw-border-solid]="message.meta?.failed"
        [class.tw-border-red-300]="message.meta?.failed"
        [class.tw-pl-3]="message.meta?.failed"
      >
        @if (message.meta?.failed) {
        <div class="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider tw-text-red-500">{{ failureLabel }}</div>
        } @for (block of message.blocks; track $index) {
        <div class="tw-flex tw-min-w-0 tw-flex-col tw-gap-1.5">
          @if (block.title) {
          <div class="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider tw-text-gray-500">
            {{ block.title }}
          </div>
          } @switch (block.type) { @case ('text') {
          <div class="tw-text-sm tw-leading-normal tw-text-gray-700">
            <ng-container *ngTemplateOutlet="segments; context: { $implicit: block.segments }"></ng-container>
          </div>
          } @case ('highlights') {
          <div
            class="tw-flex tw-flex-col tw-gap-2.5 tw-border-0 tw-border-l-2 tw-border-solid tw-border-purple-100 tw-pl-3"
          >
            @for (item of block.items; track $index) {
            <div class="tw-text-sm tw-leading-normal tw-text-gray-700">
              <span class="tw-font-semibold tw-text-gray-800">{{ item.value }}</span>
              &ngsp; <ng-container *ngTemplateOutlet="segments; context: { $implicit: item.label }"></ng-container> @if (item.context.length) {
              <span class="tw-text-gray-500">
                — <ng-container *ngTemplateOutlet="segments; context: { $implicit: item.context }"></ng-container>
              </span>
              }
            </div>
            }
          </div>
          } @case ('table') {
          <div class="tw-overflow-x-auto">
            <table class="tw-w-max tw-min-w-full tw-border-collapse tw-text-[13px]">
              <thead>
                <tr>
                  @for (column of block.columns; track $index) {
                  <th
                    class="tw-whitespace-nowrap tw-border-0 tw-border-b tw-border-solid tw-border-gray-200 tw-pb-1.5 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider tw-text-gray-500"
                    [class.tw-text-left]="$first"
                    [class.tw-text-right]="!$first"
                    [class.tw-pl-5]="!$first"
                  >
                    {{ column }}
                  </th>
                  }
                </tr>
              </thead>
              <tbody>
                @for (row of block.rows; track $index) {
                <tr>
                  @for (cell of row; track $index) {
                  <td
                    class="tw-whitespace-nowrap tw-border-0 tw-border-b tw-border-solid tw-border-gray-100 tw-py-1.5 tw-text-gray-700"
                    [class.tw-text-left]="$first"
                    [class.tw-text-right]="!$first"
                    [class.tw-pl-5]="!$first"
                  >
                    <ng-container *ngTemplateOutlet="segments; context: { $implicit: cell }"></ng-container>
                  </td>
                  }
                </tr>
                }
              </tbody>
            </table>
          </div>
          } @case ('points') {
          <div class="tw-flex tw-flex-col tw-gap-3">
            @for (point of block.items; track $index) {
            <div class="tw-text-sm tw-leading-normal tw-text-gray-700">
              @if (point.title) {
              <strong class="tw-font-semibold tw-text-purple-700">{{ point.title }}</strong>
              <br />
              } <ng-container *ngTemplateOutlet="segments; context: { $implicit: point.segments }"></ng-container>
            </div>
            }
          </div>
          } @case ('draft') {
          <div class="tw-rounded-lg tw-border tw-border-solid tw-border-gray-200 tw-bg-gray-50 tw-px-3 tw-py-2.5">
            <div class="tw-whitespace-pre-line tw-text-[13px] tw-leading-relaxed tw-text-surface-600">
              {{ block.body }}
            </div>
          </div>
          } @case ('working') {
          <ul class="tw-m-0 tw-flex tw-list-none tw-flex-col tw-gap-1 tw-p-0">
            @for (item of block.items; track $index) {
            <li class="tw-flex tw-gap-2 tw-text-[13px] tw-leading-normal tw-text-gray-500">
              <span class="tw-flex-none">·</span>
              {{ item }}
            </li>
            }
          </ul>
          } @case ('followups') { } @case ('actions') {
          <div class="tw-flex tw-flex-wrap tw-gap-2">
            @for (action of block.items; track action.id) {
            <button
              type="button"
              class="tw-inline-flex tw-cursor-pointer tw-items-center tw-gap-1.5 tw-rounded-full tw-border tw-border-solid tw-px-3 tw-py-1.5 tw-font-[inherit] tw-text-[13px]"
              [ngClass]="
                action.primary
                  ? 'tw-border-purple-100 tw-bg-purple-50 tw-font-semibold tw-text-purple-700 hover:tw-bg-purple-100'
                  : 'tw-border-gray-200 tw-bg-white tw-font-medium tw-text-gray-500 hover:tw-bg-gray-100'
              "
              (click)="onActionClick(action)"
            >
              {{ action.label }}
            </button>
            }
          </div>
          } @default {
          <div class="tw-text-sm tw-leading-normal tw-text-gray-500">{{ unknownBlockNote }}</div>
          } }
        </div>
        }
        @if (message.meta?.requestId) {
        <div
          class="tw-flex tw-items-center tw-gap-0.5 tw-pt-0.5"
          aria-label="Was this answer useful?"
        >
          <button
            type="button"
            class="tw-flex tw-h-6 tw-w-6 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-md tw-border-0 tw-bg-transparent tw-p-0 tw-text-xs hover:tw-bg-gray-100"
            [ngClass]="message.meta?.rating === 'up' ? 'tw-text-purple-700' : 'tw-text-gray-400'"
            [attr.aria-pressed]="message.meta?.rating === 'up'"
            aria-label="Good answer"
            title="Good answer"
            (click)="rate($index, 'up')"
          >
            <i [class]="message.meta?.rating === 'up' ? 'fa-solid fa-thumbs-up' : 'fa-regular fa-thumbs-up'"></i>
          </button>
          <button
            type="button"
            class="tw-flex tw-h-6 tw-w-6 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-md tw-border-0 tw-bg-transparent tw-p-0 tw-text-xs hover:tw-bg-gray-100"
            [ngClass]="message.meta?.rating === 'down' ? 'tw-text-purple-700' : 'tw-text-gray-400'"
            [attr.aria-pressed]="message.meta?.rating === 'down'"
            aria-label="Poor answer"
            title="Poor answer"
            (click)="rate($index, 'down')"
          >
            <i [class]="message.meta?.rating === 'down' ? 'fa-solid fa-thumbs-down' : 'fa-regular fa-thumbs-down'"></i>
          </button>
        </div>
        }
      </div>
      } } @if (typing) {
      <div
        class="tw-flex tw-flex-none tw-py-1.5"
        aria-label="Assistant is thinking"
      >
        <svg
          class="assistant-chat__thinking"
          viewBox="0 0 1411 1262"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            class="assistant-chat__thinking-b"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M746.896 601.548C860.186 558.869 931.956 464.646 931.956 314.601C931.956 101.207 786.812 0.791016 583.442 0.791016H0.861328V199.039H107.781V1045.49H0.861328V1248.19H583.353C800.489 1248.19 976.506 1140.96 976.506 913.086C976.506 746.469 882.372 644.36 746.896 601.548ZM348.351 199.039H527.13C628.17 199.039 700.296 248.935 700.296 354.964C700.296 460.992 628.17 510.889 527.13 510.889H348.351V199.039ZM539.916 1045.49H348.351V711.364H539.916C648.173 711.364 735.936 764.823 735.936 878.426C735.936 992.029 648.173 1045.49 539.916 1045.49Z"
          />
          <path
            class="assistant-chat__thinking-dot"
            d="M1246.03 1261.56C1337.07 1261.56 1410.87 1187.76 1410.87 1096.72C1410.87 1005.69 1337.07 931.887 1246.03 931.887C1155 931.887 1081.2 1005.69 1081.2 1096.72C1081.2 1187.76 1155 1261.56 1246.03 1261.56Z"
          />
          <g class="assistant-chat__thinking-orbit">
            <circle
              cx="705"
              cy="211"
              r="165"
            />
            <circle
              cx="1069"
              cy="841"
              r="165"
            />
            <circle
              cx="341"
              cy="841"
              r="165"
            />
          </g>
        </svg>
      </div>
      }
    </div>
  </div>

  <div
    class="tw-flex-none tw-border-0 tw-border-t tw-border-solid tw-border-gray-200 tw-bg-white tw-px-3 tw-pb-3 tw-pt-3"
  >
    @if (disabled && disabledReason) {
    <div
      class="tw-mb-2.5 tw-flex tw-items-start tw-gap-2 tw-rounded-lg tw-bg-purple-50 tw-px-3 tw-py-2 tw-text-xs tw-leading-normal tw-text-purple-700"
      role="status"
    >
      <i class="fa-regular fa-circle-info tw-mt-0.5 tw-flex-none"></i>
      <span>{{ disabledReason }}</span>
    </div>
    } @if (choicesVisible) {
    <div class="tw-mb-2.5 tw-text-base tw-font-medium tw-leading-normal tw-text-gray-800">{{ choicesPrompt }}</div>
    <div class="tw-flex tw-flex-wrap tw-gap-1.5">
      @for (suggestion of suggestions; track suggestion.id) {
      <button
        type="button"
        class="tw-inline-flex tw-items-center tw-gap-1.5 tw-cursor-pointer tw-font-[inherit] tw-rounded-full tw-border tw-border-solid tw-px-3 tw-py-1.5 tw-text-sm tw-transition-all disabled:tw-cursor-default disabled:tw-opacity-50"
        [ngClass]="
          suggestion.primary
            ? 'tw-border-purple-100 tw-bg-purple-50 tw-font-semibold tw-text-purple-700 hover:tw-bg-purple-100'
            : 'tw-border-gray-200 tw-bg-white tw-font-medium tw-text-gray-600 hover:tw-bg-gray-100'
        "
        [disabled]="cannotAsk"
        (click)="onSuggestionClick(suggestion)"
      >
        @if (suggestion.primary) {
        <i class="fa-regular fa-sparkles tw-text-sm"></i>
        }
        {{ suggestion.label }}
      </button>
      }
      <button
        type="button"
        class="tw-inline-flex tw-items-center tw-gap-1.5 tw-cursor-pointer tw-font-[inherit] tw-rounded-full tw-border tw-border-solid tw-px-3 tw-py-1.5 tw-text-sm tw-transition-all tw-border-gray-200 tw-bg-white tw-font-medium tw-text-gray-600 hover:tw-bg-gray-100 disabled:tw-cursor-default disabled:tw-opacity-50"
        [disabled]="cannotAsk"
        (click)="onOtherClick()"
      >
        Other
      </button>
    </div>
    } @if (inputVisible) { @if (followups.length) {
    <div class="tw-mb-2.5 tw-flex tw-flex-wrap tw-gap-1.5">
      @for (item of followups; track item) {
      <button
        type="button"
        class="tw-cursor-pointer tw-rounded-full tw-border tw-border-solid tw-border-gray-200 tw-bg-white tw-px-3 tw-py-1.5 tw-text-left tw-font-[inherit] tw-text-[13px] tw-text-gray-600 hover:tw-border-purple-100 hover:tw-bg-purple-50 hover:tw-text-purple-700 disabled:tw-cursor-default disabled:tw-opacity-50"
        [disabled]="cannotAsk"
        (click)="onFollowupClick(item)"
      >
        {{ item }}
      </button>
      }
    </div>
    } @if (guideVisible) {
    <div class="tw-mb-2">
      <div class="tw-mb-1.5 tw-text-sm tw-leading-normal tw-text-gray-500">{{ guideHeading }}</div>
      <ol class="tw-m-0 tw-list-none tw-p-0">
        @for (question of guideQuestions; track question) {
        <li class="tw-flex tw-gap-1.5 tw-text-sm tw-font-medium tw-leading-normal tw-text-gray-800">
          <span class="tw-flex-none tw-font-semibold tw-text-purple-700">{{ $index + 1 }}.</span>
          {{ question }}
        </li>
        }
      </ol>
      <div class="tw-mt-1.5 tw-text-xs tw-text-gray-500">{{ exampleNote }}</div>
    </div>
    }
    <div
      class="tw-rounded-lg tw-border tw-border-solid tw-border-gray-200 focus-within:tw-border-burt-purple focus-within:tw-shadow-[0_0_0_3px_theme(colors.purple.50)]"
      [ngClass]="{ 'tw-bg-gray-50': disabled }"
      [pTooltip]="disabled ? disabledReason : ''"
      tooltipPosition="top"
    >
      <div class="tw-flex tw-items-end tw-gap-2 tw-py-2 tw-pl-3 tw-pr-2">
        <textarea
          #freeTextInput
          rows="1"
          class="tw-max-h-28 tw-flex-1 tw-resize-none tw-overflow-y-hidden tw-border-0 tw-bg-transparent tw-p-0 tw-py-1 tw-font-[inherit] tw-text-sm tw-leading-normal tw-text-gray-700 tw-outline-none focus:tw-outline-none"
          [placeholder]="activePlaceholder"
          [attr.disabled]="disabled ? '' : null"
          [(ngModel)]="draft"
          (input)="onInput()"
          (keydown)="onKeydown($event)"
        ></textarea>
        <button
          type="button"
          class="tw-flex tw-h-8 tw-w-8 tw-flex-none tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-lg tw-border-0 tw-bg-burt-purple tw-p-0 tw-text-white hover:tw-bg-purple-600 disabled:tw-cursor-default disabled:tw-opacity-40"
          aria-label="Send"
          [disabled]="!canSend"
          (click)="onSend()"
        >
          <i class="fa-solid fa-arrow-right tw-text-base"></i>
        </button>
      </div>
    </div>
    @if (exampleAvailable) {
    <button
      type="button"
      class="tw-mt-1.5 tw-flex tw-cursor-pointer tw-items-center tw-gap-1 tw-border-0 tw-bg-transparent tw-p-0 tw-text-xs tw-text-gray-500 hover:tw-text-purple-700"
      (click)="acceptExample()"
    >
      <span>Press</span>
      <kbd class="tw-rounded tw-border tw-border-solid tw-border-gray-300 tw-bg-gray-50 tw-px-1 tw-font-[inherit]">
        Tab
      </kbd>
      <span>to use the example</span>
    </button>
    } }
    <div class="tw-mt-2 tw-text-center tw-text-xs tw-text-gray-500">{{ disclaimer }}</div>
  </div>
</section>
}

<ng-template #segments let-list>
  @for (segment of list; track $index) { @if (segment.bold) {
  <strong class="tw-font-semibold tw-text-gray-800">{{ segment.text }}</strong>
  } @else if (segment.code) {
  <code
    class="tw-rounded-md tw-bg-[#f3ecfc] tw-px-1.5 tw-py-px tw-font-[inherit] tw-text-[0.94em] tw-font-medium tw-text-[#4c1d95] tw-break-words"
  >
    {{ segment.text }}@if (segment.id) {
    <span class="tw-ml-1 tw-font-normal tw-text-[#8b6bc4]">#{{ segment.id }}</span>
    }
  </code>
  } @else {{{ segment.text }}} }
</ng-template>
